const collator = new Intl.Collator(undefined, { numeric: true, ignorePunctuation: true });

/**
 * Sort codes alphabetically by name
 *
 * If code has parent, the full name is used to determine its position, otherwise
 * the code's name is used
 *
 */
export const sortCodeByName = <T extends { name: string; parent?: { name: string } }>(codeA: T, codeB: T) => {
  // Compare parentName
  const fullNameA = `${codeA.parent?.name || ''} ${codeA.name}`;
  const fullNameB = `${codeB.parent?.name || ''} ${codeB.name}`;

  // Compare by parentName
  return collator.compare(fullNameA, fullNameB);
};
